import React, { useState, memo, useEffect, useCallback, ChangeEvent } from 'react';
import Spinner from "react-spinkit";

import { DataIntegrationItemProps, StatusDisabledPurchasedOrder, TableItemsDataIntegrationProps, statusEnableFinalizeIntegration } from './interface';

import { Column, Row } from 'components/Layout/Grid';
import { Visibility } from 'components/Visibility';
import { Button } from 'components/Button';
import Input from 'components/Input';
import Table from "components/Table";
import Text from 'components/Text';

import { IBatchRequestResponse } from 'models/Batch';

import HealthOperatorServices from 'services/healthOperator.service';

const TableDataIntegrationItems: React.FC<TableItemsDataIntegrationProps> = (props) => {

  const { model, dataIntegration, setIsEditBuyOrder, isEditBuyOrder } = props;

  const pageSize = 5;

  const [dataIntegrationItem, setDataIntegrationItems] = useState<IBatchRequestResponse<DataIntegrationItemProps>>();
  const [purchaseOrder, setPurchaseOrder] = useState<string>("");
  const [currentPageItem, setCurrentPageItem] = useState(0);

  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const healthOperatorServices = new HealthOperatorServices();

  useEffect(() => {
    getDataIntegrationItems();
  }, [currentPageItem]);

  const getDataIntegrationItems = useCallback(() => {
    setDataIntegrationItems(undefined);

    healthOperatorServices
      .getMessages(currentPageItem, pageSize, dataIntegration?.id)
      .then((result: IBatchRequestResponse<DataIntegrationItemProps> | undefined) => {

        if (result) {
          const { error, data, totalPages, pageSize, total } = result;

          setDataIntegrationItems({ error, data, totalPages, pageSize, total });
        }
      });

  }, [currentPageItem]);

  const savePurchaseOrder = () => {
    setLoading(true);
    healthOperatorServices
      .updateBuyOrder(dataIntegration?.id, purchaseOrder)
      .then((result: any | undefined) => {
        if (result.status != 200) {
          setErrorMessage(result.data.data);
        } else {
          setIsEditBuyOrder(!isEditBuyOrder);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const finalizeIntegration = () => {
    setLoading(true);

    healthOperatorServices
      .updateFinalizeIntegration(dataIntegration.id)
      .then((result: any | undefined) => {
        if (result.status != 200) {
          setErrorMessage(result.data.data);
        } else {
          setIsEditBuyOrder(!isEditBuyOrder);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handlePurchaseOrder = (e: ChangeEvent<HTMLInputElement>) => {
    setPurchaseOrder(e.target.value);
  };

  const enableFinalizeIntegration = (): boolean => {
    if (statusEnableFinalizeIntegration.includes(dataIntegration.statusFlow) && dataIntegration.isMultipleInvoice) {
      return true;
    }

    return false;
  };

  const enableFieldPurchaseOrder = (): boolean => {
    if (StatusDisabledPurchasedOrder.includes(dataIntegration.statusFlow)) {
      return false;
    }

    if (statusEnableFinalizeIntegration.includes(dataIntegration.statusFlow) && dataIntegration.isMultipleInvoice) {
      return false;
    }

    return true;
  };

  return (
    <Column className="animated fadeIn px-md-2 px-3 py-2 bg-white overflow-x-auto">

      <Column style={{ width: "35%" }}>
        <Visibility visible={enableFieldPurchaseOrder()}>
          <Text className="mb-1 color-blue-gray" size={12}>
            Informar a ordem de compra
          </Text>
          <Row className='align-center'>
            <Column className='flex-1'>
              <Row className="flex-1 mt-md-2 mr-md-2">
                <Input
                  onChange={(e: any) => handlePurchaseOrder(e)}
                  type="number"
                  value={purchaseOrder}
                  readOnly={false}
                  placeholder="Ordem de compra"
                  style={{
                    width: "95%"
                  }}
                />
              </Row>
            </Column>

            <Button
              onClick={() => savePurchaseOrder()}
              disabled={purchaseOrder === ""}
              className="outline d-lg-none"
              width="35%"
            >
              <Text size={14} className="color-primary font-bold px-1">
                {loading ?
                  <Spinner fadeIn="none" name="circle" color="#0E4C54" /> :
                  "Salvar dados"
                }
              </Text>
            </Button>
          </Row>
        </Visibility>
      </Column>

      <Column style={{ width: "40%" }}>
        <Visibility visible={enableFinalizeIntegration()}>
          <Text className="mb-1 color-blue-gray" size={12}>
            Para finalizar esse processo será necessário a integração manual desta Nota Fiscal
          </Text>
          <Row className='align-center'>
            <Button
              onClick={() => finalizeIntegration()}
              disabled={loading}
              className="outline d-lg-none"
              width="30%"
            >
              <Text size={14} className="color-primary font-bold px-1">
                {loading ?
                  <Spinner fadeIn="none" name="circle" color="#0E4C54" /> :
                  "Finalizar Integração"
                }
              </Text>
            </Button>
          </Row>
        </Visibility>
      </Column>

      <Text className="mb-1 color-danger mt-1" size={12}>
        {errorMessage}
      </Text>
      <Row>
        <Row className="payment-breakpoint">
          <Text className="d-block font-bold color-blue-gray mt-2 mb-1" size={12}>
            Histórico de erros na integração
          </Text>
        </Row>
      </Row>

      <Table
        trackingKey="Visualizar Histórico de erros na integração"
        error={dataIntegrationItem?.error || false}
        onReload={getDataIntegrationItems}
        currentPage={currentPageItem}
        data={dataIntegrationItem?.data}
        pageSize={pageSize}
        onPageChange={setCurrentPageItem}
        totalPages={dataIntegrationItem?.totalPages}
        model={model}
        completeBlankSpaces={false}
        rowHeight={40}
        customProps={{ dataIntegrationId: dataIntegration.id }}
        className="mb-1"
      />
    </Column>
  );
};

export default memo(TableDataIntegrationItems);
